import { render, staticRenderFns } from "./ModalPurchase.vue?vue&type=template&id=a215234e&scoped=true"
import script from "./ModalPurchase.vue?vue&type=script&lang=js"
export * from "./ModalPurchase.vue?vue&type=script&lang=js"
import style0 from "./ModalPurchase.vue?vue&type=style&index=0&id=a215234e&prod&lang=scss&scoped=true"
import style1 from "./ModalPurchase.vue?vue&type=style&index=1&id=a215234e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a215234e",
  null
  
)

export default component.exports